<!-- components/Toast.vue -->
<template>
  <transition name="fade">
    <div  class="toast-all" v-if="show">
      <div class="toast" ref="toastRef" :class="type">
        <i v-if="icon" :class="icon"></i>
        <span>{{ msg }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
import {nextTick} from "vue";

export default {
  data() {
    return {
      show: false,
      message: "",
      type: "", // success/error/loading
      duration: 2000,
      icon: ""
    };
  },
  props: ["msg"],
  // mounted() {
  //   if (this.duration > 0) {
  //     setTimeout(() => {
  //       this.show = false
  //     }, this.duration)
  //   }
  // },

  methods: {
    open() {
      this.show = true;
      this.updatePosition();
      let time = setTimeout(() => {
        this.show = false;
        clearTimeout(time);
      }, 3000);
    },
   async updatePosition() {
      // 获取当前可视区域高度
      await nextTick()
        const h = window.innerHeight;
        const toast =  this.$refs.toastRef;
        if (toast) {
          toast.style.bottom = h/2 -50  + "px";
          toast.style.opacity = 1;
        }
    },
  },
};
</script>

<style scoped>
.toast-all {
  position: fixed;
  top:0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999999999;
  pointer-events: none;
}
.toast {
  position: absolute;
  opacity: 0;
  /* top: 50%; */
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 10px 20px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 5px;
  z-index: 999999999;
  display: flex;
  align-items: center;
  border-radius: 10px;
  font-size: 26px;
}

.toast.success {
  background: rgba(0, 200, 0, 0.7);
}

.toast.error {
  background: rgba(255, 0, 0, 0.7);
}

.toast.loading {
  background: rgba(0, 0, 0, 0.7);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
